module.exports = "/templates/bds/public/font/78621321b8bf520fd49ce4c9f02ae820.woff";